import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Card as CardMaterial,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  CardMedia,
  Tooltip,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteAcuerdoColaboracion,
  getAcuerdoColaboracionById,
  postAcuerdoColaboracion,
  updateAcuerdoColaboracion,
} from "../../../../api/acuerdoColaboracion";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import Editor from "../../../components/editor/Editor";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { Delete, Visibility } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyAcuerdoColaboracion() {
  return {
    titulo: {},
    texto: {},
    logo: "",
    order: 0,
    active: true,
  };
}

export default function EditAcuerdoColaboracionPage() {
  const [acuerdoColaboracion, setAcuerdoColaboracion] = useState(getEmptyAcuerdoColaboracion());
  const imageInputRef = useRef(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null);
  const acuerdoColaboracionId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetch = async () => {
      if (!acuerdoColaboracionId) {
        disableLoadingData();
        return;
      }
      getAcuerdoColaboracionById(acuerdoColaboracionId)
        .then((res) => {
          if (res.status === 200) {
            const acuerdoColaboracion = res.data;
            setAcuerdoColaboracion(acuerdoColaboracion);
            disableLoadingData();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se pudo obtener el acuerdo de colaboración.",
          });
          history.push("/acuerdo-colaboracion");
        });
    };
    fetch();
  }, [acuerdoColaboracionId, disableLoadingData, history]);

  function saveAcuerdoColaboracion() {
    let saveAcuerdoColaboracion = acuerdoColaboracion;
    if (!acuerdoColaboracionId) {
      postAcuerdoColaboracion(saveAcuerdoColaboracion, selectedImage)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Guardado!",
              customMessage: "Acuerdo de colaboración creado correctamente.",
            });
            history.push("/acuerdo-colaboracion");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se pudo guardar el acuerdo de colaboración.",
          });
        });
    } else {
      updateAcuerdoColaboracion(acuerdoColaboracionId, saveAcuerdoColaboracion, selectedImage)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Guardado!",
              customMessage: "Cambios guardados correctamente.",
            });
            history.push("/acuerdo-colaboracion");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se pudieron guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;
      if (!acuerdoColaboracion[element]) acuerdoColaboracion[element] = {};
      let newText = acuerdoColaboracion[element];
      newText[lang] = event.target.value;
      setAcuerdoColaboracion({ ...acuerdoColaboracion, [element]: newText });
    } else setAcuerdoColaboracion({ ...acuerdoColaboracion, [element]: event.target.value });
  };

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === " ") return;
      if (!acuerdoColaboracion[element]) acuerdoColaboracion[element] = {};
      let newText = acuerdoColaboracion[element];
      newText[lang] = value;
      setAcuerdoColaboracion({ ...acuerdoColaboracion, [element]: newText });
    } else setAcuerdoColaboracion({ ...acuerdoColaboracion, [element]: value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <TextField
          id={`titulo`}
          label="Título"
          value={(acuerdoColaboracion.titulo && acuerdoColaboracion.titulo[lang]) || ""}
          onChange={handleChange("titulo", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
          fullWidth
        />
        <Editor
          body={(acuerdoColaboracion.texto && acuerdoColaboracion.texto[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("texto", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Introduce el texto del acuerdo de colaboración aquí..."}
        />
      </>
    );
  };

  const renderGeneralFields = () => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <TextField
              id="order"
              label="Orden"
              type="number"
              value={acuerdoColaboracion.order || 0}
              onChange={(e) => setAcuerdoColaboracion({ ...acuerdoColaboracion, order: parseInt(e.target.value) || 0 })}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-12">
            <CardMaterial>
              {(selectedImage || acuerdoColaboracion.logo) && (
                <CardMedia
                  component="img"
                  alt="Logo"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                    maxHeight: "200px",
                    margin: "20px 0",
                  }}
                  image={
                    selectedImage
                      ? URL.createObjectURL(selectedImage)
                      : `${SERVER_URL}/${acuerdoColaboracion.logo}`
                  }
                />
              )}
            </CardMaterial>
            <label htmlFor={"upload-media"} className="ml-0 my-4">
              <input
                ref={imageInputRef}
                style={{ display: "none" }}
                id={"upload-media"}
                name={"upload-media"}
                type="file"
                accept={"image/*"}
                onChange={(e) => {
                  setSelectedImage(e.target.files[0]);
                }}
              />
              <Button
                style={{ marginRight: "15px" }}
                color="secondary"
                component="span"
                variant="outlined"
              >
                {selectedImage ||
                (acuerdoColaboracion.logo && acuerdoColaboracion.logo !== "")
                  ? "Cambiar logo"
                  : "Subir logo"}
              </Button>
            </label>
            {(selectedImage ||
              (acuerdoColaboracion.logo && acuerdoColaboracion.logo !== "")) && (
              <>
                <Tooltip title={"Preview"}>
                  <Button
                    size="small"
                    onClick={() => setOpenPreviewDialog(1)}
                    style={{
                      marginRight: "15px",
                    }}
                  >
                    <Visibility />
                  </Button>
                </Tooltip>
                <PreviewDialog
                  title={"Preview"}
                  open={openPreviewDialog === 1}
                  setOpen={setOpenPreviewDialog}
                  file={selectedImage}
                  src={
                    selectedImage
                      ? URL.createObjectURL(selectedImage)
                      : `${SERVER_URL}/${acuerdoColaboracion.logo}`
                  }
                />
                <Tooltip title={"Delete"}>
                  <Button
                    size="small"
                    onClick={() => {
                      setSelectedImage(null);
                      setAcuerdoColaboracion({
                        ...acuerdoColaboracion,
                        logo: null,
                      });
                      if (imageInputRef.current) {
                        imageInputRef.current.value = "";
                      }
                    }}
                  >
                    <Delete />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/acuerdo-colaboracion"),
            onSave: saveAcuerdoColaboracion,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!acuerdoColaboracionId,
            setObj: setAcuerdoColaboracion,
            obj: acuerdoColaboracion,
          })}
          <CardHeader title="Editar Acuerdo de Colaboración"></CardHeader>
          <CardBody>
            {renderGeneralFields()}
            <div style={{ marginTop: "24px" }}>
              <MultilanguageTabBlock
                multilanguageTabContent={renderMultilanguageTabContent}
              />
            </div>
            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acuerdoColaboracion.active !== false}
                    onChange={() =>
                      setAcuerdoColaboracion({ ...acuerdoColaboracion, active: !acuerdoColaboracion.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>

        {acuerdoColaboracionId && (
          <>
            <ConfirmDialog
              title={"¿Estás seguro de que quieres eliminar este acuerdo de colaboración?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteAcuerdoColaboracion(acuerdoColaboracionId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Eliminado!",
                        customMessage: "Acuerdo de colaboración eliminado correctamente",
                      });
                      history.push("/acuerdo-colaboracion");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "No se pudo eliminar el acuerdo de colaboración.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}